/**
 * Created by elmar on 01/27/2017.
 */

(function($) {
    'use strict';

    (new function() {
        var __body_id = '#page__price_list_configuration__2';
        var __form    = '#step-form';

        var __field_rate = __form + ' #rate';

        /**
         ***************************************************************************
         * Init
         ***************************************************************************
         */
        this.init = function() {
            if (!$(__body_id).length) {
                return false;
            }

            __assignEvents();
        };

        /**
         ***************************************************************************
         * Events
         ***************************************************************************
         */
        var __assignEvents = function() {
            $(__field_rate).on('keypress', __numericInput);
        };

        /**
         ***************************************************************************
         * Format price input
         *
         * Allow only `delete`, 48-57 (0-9) buttons and one point
         ***************************************************************************
         */
        var __numericInput = function(e) {
            if ((e.which != 46 || $(this).val().indexOf('.') != -1) && (e.which < 48 || e.which > 57)) {
                e.preventDefault();
            }
        };

    }).init();

})(jQuery);